export enum FILE_TYPE {
  TSX = "tsx",
  TS = "ts",
}
export enum VIEWS {
  LAYOUT = "layout",
  HOME = "home",
  ABOUT_US = "about-us",
  SERVICES = "services",
  OUR_WORK = "our-work",
  CONTACT = "contact",
  BLOG = "blog",
  CAREER = "career",
  COMPONENT_SHOWCASE = "component-showcase",
  BLOG_DETAILS = "blog-details",
  CASE_DETAILS = "case-details",
  LEGAL_PAGE = "legal-page",
}
